import { render } from "./SignUpKyc2.vue?vue&type=template&id=b571550a&scoped=true&ts=true"
import script from "./SignUpKyc2.vue?vue&type=script&lang=ts"
export * from "./SignUpKyc2.vue?vue&type=script&lang=ts"

import "./SignUpKyc2.vue?vue&type=style&index=0&id=b571550a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b571550a"]])

export default __exports__